<!-- Vehicle Inventory Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center gap-3 my-1">
        <!-- View Master Dropdown -->
        <select
          class="form-select form-select-solid w-200px"
          [(ngModel)]="selectedViewMaster"
          (change)="onViewChange()">
          <option value="">Select View</option>
          <option *ngFor="let viewMaster of viewMasters" [value]="viewMaster._id">
            {{ viewMaster.name }}
          </option>
        </select>
        <!-- Search Input -->
        <!-- <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (keyup.enter)="onSearch()"
            class="form-control form-control-solid w-250px ps-13"
            placeholder="Search vehicles..." />
        </div> -->
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <button
          type="button"
          class="btn btn-sm btn-success me-3"
          [disabled]="selectedVehicles.length === 0"
          (click)="copySelectedISL()">
          <i class="ki-duotone ki-copy fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Copy ISL# ({{ selectedVehicles.length }})
        </button>
        <button
          type="button"
          class="btn btn-sm btn-dark me-3"
          [class.active]="showFiltersForm"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
          <span *ngIf="getActiveFiltersCount() > 0" class="badge badge-danger ms-2">{{ getActiveFiltersCount() }}</span>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary me-3 text-nowrap"
          (click)="exportExcel()"
          [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export Excel' }}</span>
        </button>
        <!-- <button
          type="button"
          class="btn btn-primary"
          (click)="onSearch()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button> -->
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div *ngIf="showFiltersForm" class="card-body border-top py-4">
    <div class="row g-3">
      <!-- Row 1: Date Filters -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.purchase_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Purchase Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.purchase_date_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.yard_in_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard In Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.yard_in_date_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.insp_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.insp_date_to">
      </div>
    </div>

    <div class="row g-3 mt-2">
      <!-- Row 2: More Date Filters -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.masho_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.masho_date_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sold Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.sold_date_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sold Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.sold_date_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">ETD From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.etd_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">ETD To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.etd_to">
      </div>
    </div>

    <div class="row g-3 mt-2">
      <!-- Row 3: ETA and Dropdowns -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">ETA From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.eta_from">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">ETA To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.eta_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Insp Status</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.insp_status">
          <option value="">All Status</option>
          <option *ngFor="let status of inspStatusOptions" [value]="status.value">{{ status.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Yard</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.yard">
          <option value="">All Yards</option>
          <option *ngFor="let yard of yardsList" [value]="yard._id">{{ yard.company_name }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Year From</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.year_from">
          <option value="">Any Year</option>
          <option *ngFor="let year of yearOptions" [value]="year.value">{{ year.label }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Year To</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.year_to">
          <option value="">Any Year</option>
          <option *ngFor="let year of yearOptions" [value]="year.value">{{ year.label }}</option>
        </select>
      </div>
    </div>

    <div class="row g-3 mt-2">
      <!-- Row 4: Buyer Name and Other Fields -->
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Buyer Name</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Buyer Name..."
            [(ngModel)]="buyerNameSearchTerm"
            (input)="onBuyerNameSearchInput($event)"
            (focus)="onBuyerNameInputFocus()"
            (blur)="onBuyerNameInputBlur()"
            autocomplete="off" />

          <!-- Buyer Name Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
               *ngIf="showBuyerNameDropdown && (buyerNameSearchResults.length > 0 || isBuyerNameSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isBuyerNameSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching buyers...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let buyer of buyerNameSearchResults"
               (click)="selectBuyerName(buyer)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getBuyerNameDisplayName(buyer) }}</span>
                <small class="text-muted">{{ buyer.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isBuyerNameSearching && buyerNameSearchResults.length === 0">
              No buyers found
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Auction Name</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.auction_name" placeholder="Enter auction name">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Fuel Type</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.fuel_type">
          <option value="">All Fuel Types</option>
          <option *ngFor="let fuel of fuelTypesList" [value]="fuel.slug">{{ fuel.name }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Transmission</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.transmission">
          <option value="">All Transmissions</option>
          <option *ngFor="let transmission of transmissionsList" [value]="transmission._id">{{ transmission.name }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Auction Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.auction_date_from">
      </div>
    </div>

    <div class="row g-3 mt-2">
      <!-- Row 5: More Fields -->
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Auction Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.auction_date_to">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Keyword Search</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.keyword_search" placeholder="Enter keywords">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.stock_number" placeholder="Enter stock number">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Shipping Company</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.shipping_company">
          <option value="">All Shipping Companies</option>
          <option *ngFor="let company of shippingCompaniesList" [value]="company._id">{{ company.company_name }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Source</label>
        <div class="d-flex flex-wrap gap-2 mt-2">
          <div class="form-check" *ngFor="let source of sourceOptions">
            <input
              class="form-check-input"
              type="checkbox"
              [id]="'source_' + source.value"
              [checked]="isSourceSelected(source.value)"
              (change)="onSourceChange(source.value, $any($event.target).checked)">
            <label class="form-check-label fs-8" [for]="'source_' + source.value">
              {{ source.label }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <!-- Empty column for spacing -->
      </div>
    </div>

    <div class="row g-3 mt-2">
      <!-- Row 6: Sales Person and Ship Name -->
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Person</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Sales Person..."
            [(ngModel)]="salesPersonSearchTerm"
            (input)="onSalesPersonSearchInput($event)"
            (focus)="onSalesPersonInputFocus()"
            (blur)="onSalesPersonInputBlur()"
            autocomplete="off" />

          <!-- Sales Person Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
               *ngIf="showSalesPersonDropdown && (salesPersonSearchResults.length > 0 || isSalesPersonSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesPersonSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching sales persons...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let salesPerson of salesPersonSearchResults"
               (click)="selectSalesPerson(salesPerson)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getSalesPersonDisplayName(salesPerson) }}</span>
                <small class="text-muted">{{ salesPerson.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isSalesPersonSearching && salesPersonSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Ship Name</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Ship Name..."
            [(ngModel)]="shipNameSearchTerm"
            (input)="onShipNameSearchInput($event)"
            (focus)="onShipNameInputFocus()"
            (blur)="onShipNameInputBlur()"
            autocomplete="off" />

          <!-- Ship Name Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
               *ngIf="showShipNameDropdown && (shipNameSearchResults.length > 0 || isShipNameSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isShipNameSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching ships...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let ship of shipNameSearchResults"
               (click)="selectShipName(ship)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getShipNameDisplayName(ship) }}</span>
                <small class="text-muted">{{ ship.company || 'Unknown Company' }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isShipNameSearching && shipNameSearchResults.length === 0">
              No ships found
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <!-- Empty column for spacing -->
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-sm btn-light" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Filters
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State (outside table for better visibility) -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 text-muted">Loading inventories...</p>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && vehicles.length === 0" class="text-center py-10">
      <div class="text-gray-400 fs-1 mb-3">
        <i class="ki-duotone ki-car fs-3x">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
      </div>
      <h3 class="text-gray-800 fs-2 fw-bold mb-3">No vehicles found</h3>
      <p class="text-gray-400 fs-6 mb-0">Try adjusting your search criteria</p>
    </div>

    <!-- Vehicles Table -->
    <div *ngIf="!isLoading && vehicles.length > 0" class="vh-inventory-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 vh-inventory-table">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <!-- Sticky Checkbox + Stock Number Column -->
              <th class="sticky-column min-w-180px">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()"
                      (change)="toggleSelectAll($event)" />
                  </div>
                  ISL No.
                </div>
              </th>
              <!-- Dynamic Columns -->
              <th *ngFor="let col of visibleColumns; trackBy: trackByColumn"
                  [style.min-width]="col.minWidth || '120px'">
                {{ col.header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vehicle of vehicles; trackBy: trackByFn" class="vehicle-row">
              <!-- Sticky Checkbox + Stock Number Column -->
              <td class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="isVehicleSelected(vehicle._id)"
                      (change)="toggleVehicleSelection(vehicle._id, $event)" />
                  </div>
                  <span class="fw-bold text-primary">{{ getDisplayValue(vehicle.car_no || vehicle.stock_no) }}</span>
                </div>
              </td>
              <!-- Dynamic Column Values -->
              <td *ngFor="let col of visibleColumns; trackBy: trackByColumn">
                <span *ngIf="col.format === 'badge'" class="badge badge-light-info">{{ getColumnValue(vehicle, col) }}</span>
                <span *ngIf="col.format !== 'badge'">{{ getColumnValue(vehicle, col) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
    <app-pagination
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>


